import { FETCHING_CONVERSATIONS_REQUEST, FETCHING_CONVERSATIONS_SUCCEDDED, FETCHING_CONVERSATIONS_FAILED,
  FETCHING_CONVERSATION_ACTIVITY_REQUEST, FETCHING_CONVERSATION_ACTIVITY_REQUEST_SUCCEEDED, FETCHING_CONVERSATION_ACTIVITY_REQUEST_FAILED, INVALIDATE_CONVERSATION_ACTIVITY } from 'constants/actionTypes';

import { createAction } from 'redux-actions';
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import buildUrl from 'build-url';

import _ from 'lodash';


const apiUrl = process.env.REACT_APP_API_URL;
const CONVERSATIONS_URL = `${apiUrl}/api/2.0/shares`;
const CONVERSATION_ACTIVITY_URL = `${apiUrl}/api/2.1/conversations`;

//Fetch Seek Answer
export const fetchConversations = createAction(FETCHING_CONVERSATIONS_REQUEST, (query, page, sortBy, orderBy, type) => {
  return { query, page, sortBy, orderBy, type };
});

const fetchingConversationsSucceeded = createAction(FETCHING_CONVERSATIONS_SUCCEDDED, (response) => {
  return { response };
});

const fetchingConversationsFailed = createAction(FETCHING_CONVERSATIONS_FAILED, (error) => {
  return { error };
});


function* fetchConversationsSaga(action) {

  const { query, page, sortBy, orderBy, type } = action.payload;

  const fetchConversationsAPI = () => {

    var data = {
      query: query,
      page: page,
      sort: sortBy,
      order: orderBy,
      type: type
    }

    let url = buildUrl(CONVERSATIONS_URL, {
      path: '/all'
    });

    return axios({
      method: 'POST',
      url: url,
      data: data
    }).then(response => response.data);


  }

  try {
    const response = yield call(fetchConversationsAPI);
    yield put(fetchingConversationsSucceeded(response));
    // if (callback) {
    //   callback(response);
    // }
  } catch (error) {
    yield put(fetchingConversationsFailed(error));
  }
}

export const fetchConversationActivity = createAction(FETCHING_CONVERSATION_ACTIVITY_REQUEST, (request) => {
  return { request };
});

const fetchingConversationActivitySucceeded = createAction(FETCHING_CONVERSATION_ACTIVITY_REQUEST_SUCCEEDED, (response) => {
  return { response };
});

const fetchingConversationActivityFailed = createAction(FETCHING_CONVERSATION_ACTIVITY_REQUEST_FAILED, (error) => {
  return { error };
});


function* fetchConversationActivitySaga(action) {

  const { request  } = action.payload;

  const fetchConversationActivityAPI = () => {

    let url = buildUrl(CONVERSATION_ACTIVITY_URL, {
      path: '/fetch-shares-for-conversations'
    });

    return axios({
      method: 'POST',
      url: url,
      data: request
    }).then(response => response.data);
  }

  try {
    const response = yield call(fetchConversationActivityAPI);
    yield put(fetchingConversationActivitySucceeded(response));
  } catch (error) {
    yield put(fetchingConversationActivityFailed(error));
  }
}

export const invalidateConversationActivity = createAction(INVALIDATE_CONVERSATION_ACTIVITY);

export default function* conversationsSaga() {
  yield takeEvery(FETCHING_CONVERSATIONS_REQUEST, fetchConversationsSaga);
  yield takeEvery(FETCHING_CONVERSATION_ACTIVITY_REQUEST, fetchConversationActivitySaga);
};

